export { default } from "./MTModal";
